import { createAsyncThunk } from '@reduxjs/toolkit';
import type { IProjectStatusReportScopeElementFilters } from '@app/types';
import type { IState } from '../store';
import { persistUserPreferences } from './persistUserPreferences';

export const setProjectStatusReportScopeElementFilters = createAsyncThunk<
  void,
  { changes: Partial<IProjectStatusReportScopeElementFilters> },
  { state: IState }
>('uiView/setProjectStatusReportScopeElementFilters', (_, { dispatch }) => {
  dispatch(persistUserPreferences());
});
